import React, { Component } from 'react';
import * as $ from 'jquery';
import { translate } from 'react-i18next';

class LocationsMap extends Component {

  componentDidMount() {
    $(window).resize(this.resize);
    this.resize();
  }

  componentWillUnmount() {
    $(window).off("resize", this.resize);
  }

  resize = () => {
    $('#locationsMap').css({
      paddingTop: this.props.getNavbarHeight()
    });
  }

  render() {
    const { t } = this.props;
    return(
      <iframe
        id="locationsMap"
        width="100%"
        height="100%"
        frameBorder="0"
        src="https://www.google.com/maps/d/embed?mid=1Cd02Lz4Q-XK73pQs9iA5jMJk86k"
        title={t('dashboard.locations.frame_centers')}>
      </iframe>
    );
  }
}

export default translate('common')(LocationsMap);



// WEBPACK FOOTER //
// ./src/dashboard/LocationsMap.js